const {
  GET_RESTOCK_SUBSCRIBERS_REQUEST,
  GET_RESTOCK_SUBSCRIBERS_SUCCESS,
  RESTOCK_SUBSCRIBERS_ERROR,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_RESTOCK_SUBSCRIBERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RESTOCK_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case RESTOCK_SUBSCRIBERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
